
import { first } from "lodash";
import Parser from "../../restapi/parser";
import { LotMessage, LotMessageDefault } from "../../types/types";
import { getDayOfWeek } from "../../utils/DateTimeUtils";
import { GetCurMien, GetMienCuPhapID, GetTinhId, GetUserID, isCuPhapMn } from "../../utils/common";
import { globalDexieDb } from "../DexiedbLib";
import { IParseMessageRequest, ParseMessageRequestDefaultMN } from "../dataclass/parseMessageRequest";
import { HanMucChiTiet, ICompactDataStruct, IParseMessageResult, ITraLaiDataStruct } from "../dataclass/parseMessgeResult";
import { IContactsConfig } from "../model/contactConfig";
import { IMessageDetail, MessageDetailsDefault } from "../model/messageDetails";
import { GetSoNhayTrung } from "./ketquaService";
import { SoCuocKey, SoCuocKeyDefault } from "../model/ketQuaTrung";
import { DBMessageDefault, IDBMessage } from "../model/dbMessage";
import { sha256 } from "../crypto";
import { MessageReportImpl } from "../report/totalReport";
import { ErrorCode } from "../errorCode";
import { ApiResult } from "../report/localBackend";
import { error } from "console";
import { DEBUG } from "../../../../config";
import { IContact } from "../model/contact";
import { IContactGiaThuong } from "../model/contactGiaThuong";
export async function GetDaiQuayTrongNgay(date: string): Promise<string[]> {
    const tinhId: string = GetTinhId()
    const ret: string[] = []
    const thu = getDayOfWeek(date)
    const db = globalDexieDb;
    const userDai = await db.userDaiConfig.where("[tinhId+thu]")
        .equals([tinhId, thu])
        .toArray();
    if (userDai.length > 0) {
        const item = userDai[0];
        ret.push(item.daiMn1)
        ret.push(item.daiMn2)
        ret.push(item.daiMn3)
        ret.push(item.daiMn4)
        ret.push(item.daiMt1)
        ret.push(item.daiMt2)
        ret.push(item.daiMt3)
        ret.push(item.daiMt4)
        ret.push(item.daiMb1)
    } else {
        if (GetMienCuPhapID() != 1)
            throw new Error("Không build được đài quay, fix ngay")
        else {
            ret.push("HN")
        }
    }
    return ret; //1: CN
}
export async function GetTuKhoaRiengGlobalFromCache(userId: string, mienCuPhapId: number): Promise<string[]> {
    const ret: string[] = []
    const db = globalDexieDb
    const data = await db.tuKhoaRieng.toArray()
    data.map(item => {
        const tmp = `${item.tuKhoa}/${item.thayBangTuKhoa}`
        ret.push(tmp)
    })
    return ret;
}
export async function FillContactConfig(request: IParseMessageRequest, msg: LotMessage): Promise<Error | null> {
    const db = globalDexieDb;
    const tinhId: string = GetTinhId()
    const mienCuPhapId = GetMienCuPhapID()
    const tlUserId = isNaN(Number(request.TlUserID)) ? 0 : Number(request.TlUserID)

    let data;
    if (tlUserId != 0) {
        // điền contactId từ telegramId
        const ct = await globalDexieDb.contacts.where("tlUserId").equals(tlUserId).first()
        if (ct) {
            msg.contactId = ct.contactId
        } else {
            request.ErrorCode = ErrorCode.KHONG_TIM_THAY_CON_TACT_CONFIG
            request.ErrorMsg = "Không tìm thấy cấu hình của khách này trong khai báo"
            return new Error(request.ErrorMsg)
        }

    }

    data = await db.contactsConfig.where("[contactId+mienCuPhapId+tinhId]")
        .equals([msg.contactId, mienCuPhapId, tinhId]).toArray()

    //cac tham so fix cung
    request.TachSoDinhLienDa = 1
    request.TachSoDinhLienChuyenDaCap = 1
    request.KhongNhanChuDDonLe = 1
    if (data.length > 0) {
        const config: IContactsConfig = data[0]



        if (mienCuPhapId == 2) {
            request.Area = "MN." + tinhId
            request.Region = "MN"
        } else if (mienCuPhapId == 1) {
            request.Area = "MB." + tinhId
            request.Region = "MB"
        }
        request.TlUserID = msg.tlUserId + ""
        request.TlMessageID = msg.tlMessageId + ""
        request.Type = msg.type

        if (request.CurMien == "TRUNG") {
            request.AreaDefault = (config.areaDefaultMt as number)
        } else if (request.CurMien == "NAM") {
            request.AreaDefault = (config.areaDefaultMn as number)
        } else if (request.CurMien == "BAC") {
            request.AreaDefault = (config.areaDefaultMb as number)
        }

        request.ChoPhepLapLaiLoaiCuoc = (config.choPhepLapLoaiCuoc)
        request.BatBuocDongNhatDoDaiSoCuoc = (config.batBuocDongNhatDoDaiSoCuoc)
        request.LapLaiLoaiCuocYeuCauChiRoDonViTinhTien = (config.lapLoaiCuocYeuCauChiRodvt)
        request.DenNhuKeo = (config.denNhuKeo)
        request.CauTrucNhieuMucTien = (config.nhanCauTrucNhieuMucTien as number)
        request.NhanCauTrucKhongTien = (config.nhanCauTrucKoTien as number)
        request.MnKiemTraNhapNhangDauTruKeoDen = (config.checkNhapNhangDauTruKeo as number)
        request.CheckNhapNhangSoCuocTienLe = (config.checkNhapNhangSoCuocTienLe as number)
        request.DauDuoiLenTo = (config.dauDuoiLenTo)
        if (request.DauDuoiLenTo == 0) {
            request.DauDuoiLenTo = 2
        }
        request.KyTuPhanTach = config.kytuphancach
        request.KhongChapNhanSoTrungTheXien = (config.khongChapNhanSoTrungTheXien)
        request.Da2DaiChuyenThanhDacheo = (config.xiToDc2dai as number)
        request.Da3DaiChuyenThanhDacheo = (config.xiToDc3dai)
        request.TachXienTheoKyTuPhanCach = (config.tachXien as number)
        request.RepeatReduction = (config.repeatReduction as number)
        request.LockArea = msg.lockArea
        request.NhanDLaXien = (config.nhanDLaXien)
        request.MuonTypeSet = isCuPhapMn() ? (config.muonTypeSet) : 1
        request.SpecialLexeme = await GetTuKhoaRiengGlobalFromCache(GetUserID(), mienCuPhapId)
        // các tham số mới thêm cho MB
        request.MbYcDvtDeLonHon = config.mbYcDvtDeLonHon
        request.MbYcDvtLoLonHon = config.mbYcDvtLoLonHon
        request.MbYcDvtXienLonHon = config.mbYcDvtXienLonHon
        request.XuLyDauBang = (config.xuLyDauBang)
        request.YeuCauGhiDvtDe = (config.yeuCauGhiDvtDe)
        request.YeuCauGhiDvtLo = (config.yeuCauGhiDvtLo)

        if (request.Area == "MB.HN") {
            request.SoLePrefix = "^(so|con)\\$"
        }
    } else {
        request.ErrorCode = ErrorCode.KHONG_TIM_THAY_CON_TACT_CONFIG
        request.ErrorMsg = "Không tìm thấy cấu hình của khách này trong khai báo"
        return new Error(request.ErrorMsg)

    }
    return null;
}
export async function ParseMessageLocal(msg: LotMessage): Promise<IParseMessageResult> {
    const request: IParseMessageRequest = ParseMessageRequestDefaultMN();
    request.MessageBody = msg.body;
    request.Date = msg.date
    request.DaiQuayTrongNgay = await GetDaiQuayTrongNgay(msg.date as string)
    request.TlUserID = msg.tlChatId + ""
    request.TlMessageID = msg.tlMessageId + ""
    request.ChatID = msg.tlChatId + ""
    request.CurMien = msg.curMien
    request.Type = msg.type
    request.LockArea = msg.lockArea
    const error = await FillContactConfig(request, msg)

    const result = await Parser.previewMessage(request)
    if (request.ErrorCode > 0) {
        result.responseText = request.ErrorMsg
        result.errorCode = 1
    }
    if (error) {
        result.responseText = error.message
        result.errorCode = 1
    }
    const data: IParseMessageResult = result.data;
    return data;
}
export async function GetMienDaiCuocId(d: string): Promise<number> {
    let ret = 0;
    const dais = extractDai(d)
    const dai = dais[0]
    const data = await globalDexieDb.dmDai.where("daiId").equals(dai).first()
    ret = data ? data?.mienDaiCuocId : 0
    if (ret == 0) {
        throw new Error(`Không tìm thấy miền đài cược, fix lỗi":${dai}`)
    }
    return ret;
}
export function extractDai(dai: string): string[] {
    const ret: string[] = []
    dai.split(".").map(item => {
        ret.push(item)
    })
    if (ret.length == 1)
        ret.push("")
    return ret;
}
export async function FillGiaThuong(
    mienCuPhapId: number, mienDaiCuocId: number,
    loaiCuocId: string, contactId: number, dataRow: IMessageDetail): Promise<Error | null> {
    const found = await globalDexieDb.contactGiaThuong.where("[mienCuPhapId+mienDaiCuocId+loaiCuocId+contactId]")
        .equals([mienCuPhapId, mienDaiCuocId, loaiCuocId, contactId]).first()
    if (found) {
        dataRow.gia = found.gia
        dataRow.hsThuong = found.hsthuong
        dataRow.soGiai = found.soGiai
        dataRow.khachAnPt = found.khAn
        dataRow.tuAnPt = found.tuAn
        dataRow.soNhayTrung = 0 // tính thưởng sau
    } else {
        return new Error("Không tìm thấy giá, thưởng")
    }
    return null
}
export async function FillSoNhayTrung(dataRow: IMessageDetail, msg: LotMessage, tinhId: string) {
    const soCuocKey: SoCuocKey = SoCuocKeyDefault()
    soCuocKey.Area1 = dataRow.daiId1
    soCuocKey.Area2 = dataRow.daiId2 || ""
    soCuocKey.LoaiCuoc = dataRow.loaiCuocId
    soCuocKey.SoCuoc = dataRow.soCuoc
    const config: IContactsConfig | undefined = await globalDexieDb.contactsConfig.where("[contactId+mienCuPhapId+tinhId]")
        .equals([msg.contactId, GetMienCuPhapID(), tinhId]).first()
    if (config) {
        soCuocKey.MN_TinhThuongDaXien_05 = (config.mnDax05)
        soCuocKey.MN_TinhThuongDaXien_2 = (config.mnDax2)
        soCuocKey.MN_TinhThuongDaThang_05 = (config.mnDat05)
        soCuocKey.MN_TinhThuongDaThang_2 = (config.mnDat2)
        soCuocKey.MB_TinhThuongDaThang_05 = (config.mbDat05)
        soCuocKey.MB_TinhThuongDaThang_2 = (config.mbDat2)
        soCuocKey.MB_TinhThuongDaThang_05_NhieuLan = (config.mbDat05NhieuLan)
        soCuocKey.MN_TinhThuongDaThang_05_NhieuLan = (config.mnDat05NhieuLan)
        soCuocKey.MN_TinhThuongDaXien_05_NhieuLan = (config.mnDax05NhieuLan)
    }
    dataRow.soNhayTrung = await GetSoNhayTrung(soCuocKey, msg.date as string)
    return;
}
/**Tính thưởng toàn bộ data đã phân tích*/
export async function TinhThuongAllLocal(date: string) : Promise<number> {
    const msgs = await globalDexieDb.dbmessages.where("date").equals(date).toArray()
    if (DEBUG)
        console.log("TinhThuongAllLocal Bat dau", date, new Date().toLocaleString(), msgs.length)
    let detailsCount = 0
    for (const msg of msgs) {
        const lotMsg: LotMessage = LotMessageDefault()
        lotMsg.date = date;
        lotMsg.contactId = msg.contactId;
        const details = await globalDexieDb.messageDetails.where("messageId").equals(msg.messageId!).toArray()

        for (const detail of details) {
            await FillSoNhayTrung(detail, lotMsg, msg.tinhId!)
            //await globalDexieDb.messageDetails.put(detail)
        }
        detailsCount += details.length
        await globalDexieDb.messageDetails.bulkPut(details)

    }
    if (DEBUG)
        console.log("TinhThuongAllLocal Xong", date, new Date().toLocaleString(), detailsCount, " records")
    return detailsCount
}
export function MapLoaiCuocToDB(parserLoaiCuoc: string, so: string, region: string): string {
    switch (parserLoaiCuoc) {
        case "DC":
            return "DaX";
        case "XIUCHU":
            return "XC";
        case "X":
            if (region === "MB") {
                if (so.length === 5) {
                    parserLoaiCuoc = "Xi2";
                } else if (so.length === 8) {
                    parserLoaiCuoc = "Xi3";
                } else if (so.length === 11) {
                    parserLoaiCuoc = "Xi4";
                }
            } else {
                return "DaT";
            }
            break;
        case "XA":
            if (region === "MB") {
                if (so.length === 5) {
                    parserLoaiCuoc = "Xi2A";
                } else if (so.length === 8) {
                    parserLoaiCuoc = "Xi3A";
                } else if (so.length === 11) {
                    parserLoaiCuoc = "Xi4A";
                }
            } else {
                return "DaT";
            }
            break;
        case "LB":
            if (so.length === 2) {
                return "Lo2C";
            } else if (so.length === 3) {
                return "Lo3C";
            } else if (so.length === 4) {
                return "Lo4C";
            }
            break;
        case "DAU":
            if (so.length === 2) {
                return "Dau2C";
            } else if (so.length === 3) {
                return "XcDau";
            } else if (so.length === 4) {
                return "Dau4C";
            }
            break;
        case "DUOI":
            if (so.length === 2) {
                return "Duoi2C";
            } else if (so.length === 3) {
                return "XcDuoi";
            } else if (so.length === 4) {
                return "Duoi4C";
            }
            break;
        case "6LO":
            if (so.length === 2) {
                return "6Lo2C";
            } else if (so.length === 3) {
                return "6Lo3C";
            }
            break;
        case "7LO":
            if (so.length === 2) {
                return "7Lo2C";
            } else if (so.length === 3) {
                return "7Lo3C";
            }
            break;
        case "8LO":
            if (so.length === 2) {
                return "8Lo2C";
            }
            break;
        case "XCDAU":
            return "XcDau";
        case "XCDUOI":
            return "XcDuoi";
        // các loại cược của miền bắc
        case "D":
            return "De";
        case "L":
            return "Lo";
        case "3":
            return "3c";
        case "31":
            return "3c1";
        case "31A":
            return "3c1A";
        case "3A":
            return "3cA";
        case "DA":
            return "DeA";
        case "1":
            return "Giai1";
        case "LA":
            return "LoA";
        case "1A":
            return "Giai1A";
        default:
            return parserLoaiCuoc;
    }
    return parserLoaiCuoc;
}
export function MapLoaiCuocToDBEx(parserLoaiCuoc: string, region: string): string {
    switch (parserLoaiCuoc) {
        case "DC":
            return "DaX";
        case "XIUCHU":
            return "XC";
        case "X":
            if (region === "MB") {

            } else {
                return "DaT";
            }
        case "XA":
            if (region === "MB") {

            } else {
                return "DaT";
            }
        case "LB":
            break;
        case "DAU":
            break;
        case "DUOI":
            break;
        case "6LO":
            break;
        case "7LO":
        case "8LO":
        case "XCDAU":
            return "XcDau";
        case "XCDUOI":
            return "XcDuoi";
        // các loại cược của miền bắc
        case "D":
            return "De";
        case "L":
            return "Lo";
        case "3":
            return "3c";
        case "31":
            return "3c1";
        case "31A":
            return "3c1A";
        case "3A":
            return "3cA";
        case "DA":
            return "DeA";
        case "1":
            return "Giai1";
        case "LA":
            return "LoA";
        case "1A":
            return "Giai1A";
        default:
            return parserLoaiCuoc;
    }
    return parserLoaiCuoc;
}

export async function ParseAndSaveMessageLocal(msg: LotMessage): Promise<ApiResult> {
    const result: ApiResult = {
        responseText: "",
        errorCode: 0,
        data: null,
        dataEx: null,
    }
    const parserResult: IParseMessageResult = await ParseMessageLocal(msg)
    result.data = parserResult
    if (parserResult.parseStatus != "parseOK") {

        return result;
    }
    ///
    const db = globalDexieDb
    const contactId = msg.contactId
    const contact = await globalDexieDb.contacts.get(contactId)

    if (!contact) {
        const text = "không tìm thấy contact/TeleId:" + msg.tlUserId +
            " Title:" + msg.tlChatTitle
        parserResult.responseText = text
        console.log(parserResult.responseText)
        result.errorCode = 1;
        result.responseText = text;
        return result;
    }

    //xoá trước khi lưu nếu là tin tele
    if (msg.tlMessageId && msg.tlMessageId != 0) {
        const found = await globalDexieDb.dbmessages.where("tlMessageId").equals(msg.tlMessageId)
            .first()
        if (found) {
            const msgId = found!.messageId || 0
            await globalDexieDb.dbmessages.delete(msgId)
            await globalDexieDb.messageDetails.where("messageId").equals(msgId).delete()
        }
    }

    const dbmessage: IDBMessage = DBMessageDefault()
    dbmessage.contactId = contactId;
    dbmessage.body = msg.body;
    dbmessage.originBody = msg.bodyOrigin
    dbmessage.type = msg.type
    dbmessage.dataChecksum = parserResult.checkSum
    dbmessage.textChecksum = await sha256(msg.body)
    dbmessage.soTin = parserResult.checkSum
    dbmessage.soTin = parserResult.soTin
    dbmessage.date = parserResult.date
    dbmessage.time = msg.time
    dbmessage.mienCuPhapId = GetMienCuPhapID()
    dbmessage.tinhId = contact ? contact.tinhId : ""
    dbmessage.tlChatId = 0
    dbmessage.tlMessageId = 0
    if (msg.tlChatId)
        dbmessage.tlChatId = (msg.tlChatId)
    if (msg.tlMessageId)
        dbmessage.tlMessageId = msg.tlMessageId
    dbmessage.userId = Number(GetUserID())
    dbmessage.textChecksum = await sha256(msg.body)
    // kiểm tra trùng tin
    const found = await globalDexieDb.dbmessages.where("textChecksum").equals(dbmessage.textChecksum)
        .and((item: IDBMessage) => {
            return item.tlChatId != 0 && item.tlMessageId != 0
        })
        .toArray()
    let trungTin = false;
    for (let row of found) {
        if (row.tlChatId == dbmessage.tlChatId && row.type == dbmessage.type) {
            trungTin = true;
            break;
        }
    }
    if (trungTin) {
        result.responseText = "Tin trùng chỉ lấy 1 lần"
        parserResult.totalErrorText = "Tin trùng chỉ lấy 1 lần"
        parserResult.responseText = "Tin trùng chỉ lấy 1 lần"
        result.errorCode = 0;
        return result;
    }
    const msgid = await globalDexieDb.dbmessages.add(dbmessage)
    dbmessage.messageId = msgid
    //globalDexieDb.dbmessages.put(dbmessage)

    const mienCuPhapId = GetMienCuPhapID()
    const insertData: IMessageDetail[] = []
    const promise = parserResult.compactData.map(async (item: ICompactDataStruct) => {
        const details: IMessageDetail = MessageDetailsDefault()
        details.messageId = msgid
        details.mienDaiCuocId = await GetMienDaiCuocId(item.dai)
        const dais = extractDai(item.dai)
        details.daiId1 = dais[0]
        details.daiId2 = dais[1]
        details.diem = item.diem
        details.loaiCuocId = MapLoaiCuocToDB(item.loai, item.so, parserResult.region)
        details.soCuoc = item.so
        //
        const err = await FillGiaThuong(mienCuPhapId, details.mienDaiCuocId, details.loaiCuocId, contactId, details)
        if (err) {
            result.responseText = err.message
        }
        await FillSoNhayTrung(details, msg, contact!.tinhId || "")
        if (msg.type == 2) {
            details.heSoNhan = -1;
        }
        //db.messageDetails .put(details)
        insertData.push(details)
    })
    await Promise.all(promise)
    globalDexieDb.messageDetails.bulkPut(insertData)

    result.data = parserResult
    if (contact.autoOk) {
        parserResult.tongSoTinDen = await GetTongSoTinDen(parserResult.date, contactId)

    }
    return result
}

export async function GetTongSoTinDen(date: string, contactId: number): Promise<number> {
    const userId = GetUserID()
    const ret = await globalDexieDb.dbmessages.where("[date+contactId]").equals([date, contactId])
        .and(function (item) {
            return item.userId + "" == userId && item.type == 1
        }).count()

    return ret
}
export async function GetTongSoTinDi(date: string, contactId: number): Promise<number> {
    const userId = GetUserID()
    globalDexieDb.dbmessages.where("[date+contactId]").equals([date, contactId])
        .and(function (item) {
            return item.userId + "" == userId && item.type == 2
        }).count()

    return 0
}
async function GetContactByIdFromCache(contactId: number): Promise<IContact | undefined> {
    const ret = await globalDexieDb.contacts.get(contactId)
    return ret
}
async function GetContactGiaThuongByIdFromCache(): Promise<IContactGiaThuong | undefined> {
    const ret = await globalDexieDb.contactGiaThuong.get(1)
    return ret
}

function KiemTraTraLaiSoVuotNeuViPham(contactId: number,
    parsedData: IParseMessageResult): [ITraLaiDataStruct[], string] {
    let tinTraLai: string = "";
    let traLai: ITraLaiDataStruct[] = [];
    /* const contact = GetContactByIdFromCache(contactId);
    const user = GetUserByIdFromCache(contact.UserID);
    let region: string = "MN";
    if (user.MienCuPhapID === 1) {
        region = "MB";
    }
    const hanMucChitiet: HanMucChiTiet = BuildHanMucChiTietByContactId(contactId);
    const data = GetGiuLai(contactId, parsedData.date, parsedData.loaiCuocList, parsedData.daiList, region);
    for (const item of parsedData.CompactData) {
        const key = GetKeyHanMucChiTiet(contactId, item.Dai, item.Loai, item.So, region);
        const found = hanMucChitiet.ByKey[key];
        if (found !== 0) {
            // Check detailed quota
            // console.log(`Existing detailed quota`, item);
            const tongDiemNeuNhan = data[key];
            if (tongDiemNeuNhan > found) {
                // console.log(`If received, exceeded specific quota`, item, tongDiemNeuNhan, item.Diem);
                const tl: ITraLaiDataStruct = {
                    dai: item.Dai,
                    loai: MapLoaiCuocToDBEx(item.Loai, region),
                    so: item.So,
                    diemDaNhan: data[key],
                    hanMuc: found,
                    diemThem: data[key] - found, // actual points to be returned
                };
                if (tl.diemThem > 0) {
                    traLai.push(tl);
                }
            }
        } else {
            const loai = MapLoaiCuocToDB(item.Loai, item.So, region);
            const hmChung = GetContactGiaThuongByIdFromCache(contactId, user.MienCuPhapID, GetMienDaiCuocIDFromRegion(region), loai);
            if (hmChung.NhanMax !== 0) {
                // Handle common quota exceeded
                // console.log(`Handling common quota`, item);
                const tongDiemNeuNhan = data[key];
                if (tongDiemNeuNhan > hmChung.NhanMax) {
                    // console.log(`If received, exceeded common quota`, item, tongDiemNeuNhan, hmChung.NhanMax);
                    const tl: model.TraLaiDataStruct = {
                        Dai: item.Dai,
                        Loai: global.MapLoaiCuocToDBEx(item.Loai, region),
                        So: item.So,
                        DiemDaNhan: data[key],
                        HanMuc: hmChung.NhanMax,
                        DiemThem: data[key] - hmChung.NhanMax, // actual points to be returned
                    };
                    if (tl.DiemThem > 0) {
                        traLai.push(tl);
                    }
                }
            }
        }
    } */
    return [traLai, tinTraLai];
}
